/*
* ZFF Store Locator App Modifications
*
*/
                          
  window.addEventListener('load', function(){

    // override BSS button styles
    var bssButtons = document.querySelectorAll('#bss-location-btn, #bss-search-btn');
    for (var i = 0; i < bssButtons.length; i++) {
        bssButtons[i].classList.add("btn", "caps");
    }
  
    // modified duplicate of Store Locations array
    const locationsList = bssStoreLocatorList0.map(location => {
      return {
        ...location,
        web: location.lat + ", " + location.lng // location.address + ", " + location.city + ", " + location.state + " " + location.zipCode
      };
    });
    // Hold - wait for app to finish running (3-3.5s) before executing
  
    function loadDirectionsBtn() {
  		// new array of addresses from locations only
      let directionsList = locationsList.map(directionsURL => directionsURL.web);
      const locationResults = document.querySelectorAll('.bss-store-result');
      const locationCards = Array.from(locationResults);
   
      // trigger one-time click on default location - 1st result
      document.querySelector('.bss-store-result:first-of-type').click();
  
      locationCards.forEach((locationCard, index) => {
        let locationName = locationCard.querySelector('div:first-of-type > a');
        let locationLink = locationCard.querySelector('a:last-of-type[href]');
        let locationIcon = locationCard.querySelector('svg:last-of-type');
        locationName.classList.add("h4");
        if (locationLink != null && locationLink.innerHTML.indexOf('google.com/maps') !== -1) {
          locationIcon.style.display = "none";
          let locationIndex = index;
          getDirections(locationLink, locationIndex);
        } else {
          // console.log('locationLink = ' + locationLink);
        }
      });
  
      function getDirections(address, i) {
        let directionsBtn = address;
        directionsBtn.removeAttribute('style');
        directionsBtn.style.textDecoration = "none";
        directionsBtn.classList.add("btn", "btn--outline", "caps");
        directionsBtn.innerHTML = 'Directions';
        directionsBtn.setAttribute('href', 'https://www.google.com/maps?daddr=' + directionsList[i]);
      }
      let btnSearch = document.getElementById('bss-search-btn');
    	btnSearch.onclick = function(){
        loadDirectionsBtn();	
       };
	}
    for (let i = 2000; i <= 6000; i = i + 100) {
    	setTimeout(loadDirectionsBtn, i);
    }
	

  });
    